import Tr from 'translations/Translations';

const createItem = (trKey, value = Tr(trKey)) => ({
	label: Tr(trKey),
	value,
})

export const POSITION_VALUE = {
	// DEFAULT: '1',
	// OTHER: '6',
	CHAIRMAN: 'CHAIRMAN',
	EXPERT: 'EXPERT',
	OTHER: 'OTHER'
}

export default [
	createItem('pg_position_1', POSITION_VALUE.CHAIRMAN),
	createItem('pg_position_5', POSITION_VALUE.EXPERT),
	createItem('position_6', POSITION_VALUE.OTHER),
]